// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".heading[data-v-7d41a536]{font-family:gelica,sans-serif;font-size:300%}.heading[data-v-7d41a536],a[data-v-7d41a536]{--tw-text-opacity:1;color:#f1832f;color:rgb(241 131 47/var(--tw-text-opacity))}a[data-v-7d41a536]{text-decoration-line:none;transition-duration:.15s}a[data-v-7d41a536]:hover{opacity:.75}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
